import type { FileConfig, FileItem } from '@types';

interface Props {
  folder: FileItem;
}

function TagsAndUsersDropDownMenu({ folder }: Props) {
  const createAccessList = (permission: FileConfig) => {
    const combined = [
      ...(permission.allowed_users_by_user_name?.map(
        (user) => user.user_name
      ) || []),
      ...(permission.allowed_tags_by_user_name?.map((tag) => tag.user_name) ||
        []),
    ];

    // Use a Set to remove duplicates and convert it back to an array
    const uniqueAccessList = Array.from(new Set(combined));

    // Join the array into a string
    return `${uniqueAccessList.join(', ')} has access`;
  };

  return (
    <div className='text-white lowercase p-2 pb-4'>
      {folder?.permissions?.map((permission) => {
        if (folder.id === permission.fileId) {
          return (
            <span key={permission.fileId}>{createAccessList(permission)}</span>
          );
        }
        return null;
      })}
    </div>
  );
}

export default TagsAndUsersDropDownMenu;
